/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { LogoYandexZenIcon16Light } from './LogoYandexZenIcon16Light';
import { LogoYandexZenIcon16Regular } from './LogoYandexZenIcon16Regular';
import { LogoYandexZenIcon16Solid } from './LogoYandexZenIcon16Solid';
import { LogoYandexZenIcon20Light } from './LogoYandexZenIcon20Light';
import { LogoYandexZenIcon20Regular } from './LogoYandexZenIcon20Regular';
import { LogoYandexZenIcon20Solid } from './LogoYandexZenIcon20Solid';
import { LogoYandexZenIcon24Regular } from './LogoYandexZenIcon24Regular';
import { LogoYandexZenIcon24Solid } from './LogoYandexZenIcon24Solid';
import { LogoYandexZenIcon32Regular } from './LogoYandexZenIcon32Regular';
import { LogoYandexZenIcon64Regular } from './LogoYandexZenIcon64Regular';
var sizes = {
    16: {
        light: LogoYandexZenIcon16Light,
        regular: LogoYandexZenIcon16Regular,
        solid: LogoYandexZenIcon16Solid,
    },
    20: {
        light: LogoYandexZenIcon20Light,
        regular: LogoYandexZenIcon20Regular,
        solid: LogoYandexZenIcon20Solid,
    },
    24: {
        regular: LogoYandexZenIcon24Regular,
        solid: LogoYandexZenIcon24Solid,
    },
    32: {
        regular: LogoYandexZenIcon32Regular,
    },
    64: {
        regular: LogoYandexZenIcon64Regular,
    },
};
export var LogoYandexZenIcon = forwardRef('LogoYandexZenIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
